<template>
    <div class="history-com">
        <div class="tag-con">
            <div v-if="$store.state.historyList && $store.state.historyList.length" class="closeAll" @click="closeAll">
                <i class="el-icon-error"></i>
            </div>
            <div
                @click="clickTag(tag)"
                v-for="(tag,index) in $store.state.historyList"
                :key="tag.meta.navName + index"
            >
                <el-tag
                    :class="{act:tag.meta.navName == $route.meta.navName}"
                    closable
                    type="info"
                    @close="closeTag(index)"
                >{{tag.meta.navName}}</el-tag>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    methods: {
        closeAll(){
            this.$clearHistory()
        },
        clickTag(e) {
            this.$router.push(e.path + '?refresh=no')
        },
        closeTag(e) {
            this.$store.state.historyList.splice(e, 1);
        }
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
.history-com {
}
</style>
<style lang="scss">
.history-com {
    height: 100%;
    .tag-con {
        position: absolute;
        bottom: 0;
        display: flex;
        .closeAll{
            border-radius: 4px;
            background: #CDD0D4;
            color: #888;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            border: 1px solid #666;
            cursor: pointer;
            width: 32px;
            height: 32px;
            margin-left: 12px;
            margin-right: 5px;
            text-align: center;
            line-height: 32px;
            font-size: 13px;
        }
        .closeAll:hover{
            background: #fff;
            color: #f44;
        }
        .el-tag {
            border-color: #666;
            background: #CDD0D4;
            color: #505050;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            cursor: pointer;
            padding: 0 12px;
        }
        .el-tag:hover {
            color: #222;
            background: #edf1f5;
        }
        .act {
            background: #fff;
            color: #222;
        }
        .act:hover {
            background: #fff;
            color: #222;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/vue/components/history.vue